import { useState } from "react";
import { webUrl } from "../../lib/api";
import { CaptainBadge } from "./kit";

const initials = (n = "") => n.split(/\s+/).filter(Boolean).slice(0, 2).map((w) => w[0]).join("").toUpperCase();

const Spot = ({ s }) => {
  const [ok, setOk] = useState(true);
  return (
    <li data-testid={`fan-lineup-${s.pos.toLowerCase()}`} className="flex items-center gap-3 rounded-2xl border border-[#1E293B] bg-[#0F172A] p-3 sm:flex-col sm:p-4 sm:text-center">
      <span className="w-10 font-display text-2xl font-black text-[#39FF14] sm:w-auto">{s.pos}</span>
      <div className="flex h-14 w-14 shrink-0 items-center justify-center overflow-hidden rounded-full border-2 border-[#39FF14]/60 bg-[#162032] font-display text-lg font-black text-white">
        {s.photo_url && ok ? <img src={webUrl(s.photo_url)} alt="" onError={() => setOk(false)} className="h-full w-full object-cover" /> : s.name ? initials(s.name) : "?"}
      </div>
      <div className="min-w-0 flex-1 sm:flex-none">
        <p className="flex items-center gap-2 truncate font-display text-lg font-black uppercase leading-tight text-white sm:justify-center">
          <span className="truncate">{s.name ?? "TBD"}</span>{s.captain && <CaptainBadge testid={`fan-lineup-captain-${s.pos.toLowerCase()}`} />}
        </p>
        {s.jersey != null && <p className="font-mono-gd text-xs text-slate-400">#{s.jersey}</p>}
      </div>
    </li>
  );
};

/** Coach-posted Starting Five, shown on the public fan page until shortly after the game. */
export const FanLineup = ({ lineup }) => {
  const starters = Array.isArray(lineup?.starters) ? lineup.starters : [];
  if (!starters.length) return null;
  const game = [lineup.opponent && `vs ${lineup.opponent}`, lineup.when, lineup.where].filter(Boolean).join(" \u00b7 ");
  return (
    <section data-testid="fan-lineup" className="mb-10 rounded-3xl border border-[#39FF14]/30 bg-[#39FF14]/[0.04] p-5 sm:p-8">
      <p className="font-mono-gd text-xs uppercase tracking-[0.25em] text-[#39FF14]">Game day{lineup.level === "jv" ? " \u00b7 JV" : ""}</p>
      <h2 className="mt-2 font-display text-3xl font-black uppercase leading-none text-white sm:text-4xl">Starting five</h2>
      {game && <p data-testid="fan-lineup-game" className="mt-2 text-sm text-slate-300">{game}</p>}
      <ol className="mt-6 grid grid-cols-1 gap-3 sm:grid-cols-5">{starters.map((s) => <Spot key={s.pos} s={s} />)}</ol>
      {starters.some((s) => s.captain) && <p className="mt-4 flex items-center gap-2 text-xs text-slate-400"><CaptainBadge className="h-4 w-4 text-[9px]" />Team captain</p>}
    </section>
  );
};
